import classNames from 'classnames';
import type { Recommendation } from '../../types';
import Input from '../../ui/Input';
import * as styles from '../Recommendations.css';
import type { TRecommendationAttributes } from '../Recommendations.types';

interface Props {
  defaultEmail?: string;
  isLive: boolean;
  isPopupForm: boolean;
  portalElement?: HTMLElement;
  email: string;
  setEmail: (email: string) => void;
  handleSubmit: () => void;
  inputPlaceholderText?: string;
  attrs: TRecommendationAttributes;
  buttonText?: string;
  selectedRecommendations: Recommendation[];
}

const RecommendationsForm = ({
  defaultEmail,
  isLive,
  isPopupForm,
  portalElement,
  email,
  setEmail,
  handleSubmit,
  attrs,
  buttonText,
  selectedRecommendations,
  inputPlaceholderText,
}: Props) => {
  const {
    inputBackgroundColor,
    inputBorderRadius,
    inputBorderColor,
    inputBorderWidth,
    inputBorderStyle,
    buttonCustomBackgroundColor,
    buttonCustomTextColor,
    buttonBorderRadius,
    buttonBorderColor,
    buttonBorderWidth,
    buttonBorderStyle,
  } = attrs;

  return (
    <>
      {defaultEmail ? (
        <input name="email" type="hidden" value={defaultEmail} />
      ) : (
        <Input
          type="email"
          autoComplete="off"
          name="email"
          placeholder={inputPlaceholderText || 'placeholder text'}
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && portalElement) {
              handleSubmit();
            }
          }}
          style={{
            backgroundColor: inputBackgroundColor,
            borderRadius: inputBorderRadius,
            borderColor: inputBorderColor,
            borderWidth: inputBorderWidth,
            borderStyle: inputBorderStyle,
            padding: 8,
          }}
          className={classNames('w-full', !isLive && 'pointer-events-none', styles.inputText)}
        />
      )}

      <button
        type={isPopupForm && portalElement ? 'button' : 'submit'}
        style={{
          width: '100%',
          padding: 8,
          backgroundColor: buttonCustomBackgroundColor,
          color: buttonCustomTextColor,
          borderRadius: buttonBorderRadius,
          borderColor: buttonBorderColor,
          borderWidth: buttonBorderWidth,
          borderStyle: buttonBorderStyle,
          marginTop: 8,
          fontWeight: 600,
        }}
        className={classNames(!isLive && 'pointer-events-none')}
        onClick={isPopupForm && portalElement ? handleSubmit : undefined}
      >
        <span className={classNames(styles.submitButton, !isLive && 'pointer-events-none')}>
          {`${buttonText}${selectedRecommendations.length > 0 ? ` (${selectedRecommendations.length})` : ''}`}
        </span>
      </button>
    </>
  );
};

export default RecommendationsForm;
